const PROD_PRODUCT_IDS = {
  advertisingIntelligence: 'MP-94072e44d5364872b672d7ab4fc7a7e8',
  socialMarketing: 'SM',
  listingBuilder: 'MS',
  reputationManagement: 'RM',
  websitePro: 'MP-ee4ea04e553a4b1780caf7aad7be07cd',
  customerVoice: 'MP-c4974d390a044c28aec31e421aa662b2',
  taskManager: 'MP-QQF46WQ8W4TXTD8CBX8P6X7XBV4KBNW4',
  localAds: 'MP-SPFJ58V2NJHN8Z542JM76XR4G4QW62DG',
  inboxPro: 'MP-DKT6XHPM6NCCDNK2TPDPVD3PG3V7ZHWP',
};

const DEMO_PRODUCT_IDS = {
  advertisingIntelligence: 'MP-94072e44d5364872b672d7ab4fc7a7e8',
  socialMarketing: 'SM',
  listingBuilder: 'MS',
  reputationManagement: 'RM',
  websitePro: 'MP-9cc9f21f0a234a46ad78087fc09f16bc',
  customerVoice: 'MP-fba21121b71148c9bb33e11fcd92d520',
  taskManager: 'MP-R7G3NP55T725DM5VGDBHTWVT8L73MKXN',
  inboxPro: 'MP-SN554CTLCKV2XLZ7XZ3N2WV8S38RZMQW',
};

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDqWGgrDbTRHlVwo_ViFD05agVFY7Do7zI';

export const environment: string = globalThis.environment || 'prod';
export const deployment: string = globalThis.deployment || null;
export const partnerId: string = globalThis.partnerId?.toUpperCase() || null;
export const devServer: boolean = globalThis.devServer || false;
export const productIds: { [key: string]: string } = environment === 'demo' ? DEMO_PRODUCT_IDS : PROD_PRODUCT_IDS;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const wootric: any = globalThis.wootric || null;
